export default {
  // vue-i18n messages (accessed via useI18n t() function)
  messages: {
    // --- Common ---
    common: {
      save: '保存',
      cancel: '取消',
      confirm: '确认',
      delete: '删除',
      edit: '修改',
      refresh: '刷新',
      loading: '加载中...',
      error: '错误',
      success: '成功',
      search: '搜索',
      noData: '没有数据',
      online: '在线',
      offline: '离线',
      enabled: '启用',
      disabled: '禁用',
      close: '关闭',
      back: '返回',
      next: '下一步',
      submit: '提交',
      operationFailed: '操作失败: {msg}',
      copySuccess: '已复制到剪贴板',
      justNow: '刚刚',
      minutesAgo: '{n} 分钟前',
      hoursAgo: '{n} 小时前',
      daysAgo: '{n} 天前',
      unknown: '未知',
      timeFormatError: '时间格式错误',
      user: '用户',
      joined: '加入',
    },

    // --- Home ---
    home: {
      greeting: {
        lateNight: '夜深了',
        morning: '早上好',
        noon: '中午好',
        afternoon: '下午好',
        evening: '晚上好',
      },
      proMember: 'Pro 会员',
      joinedDate: '{date} 加入',
      manageServers: '管理服务器',
      stats: {
        totalServers: '服务器总数',
        onlineServers: '在线服务器',
        proServers: 'Pro 服务器',
        connected: '已连接',
        disconnected: '未连接',
        realtimeChannel: '实时通道',
      },
      validUntil: '有效期至 {date}',
      manageSubscription: '管理订阅',
      upgradeToPro: '升级到 Pro',
      upgradeDesc: '解锁远程管理、实时监控等高级功能',
      learnMore: '了解更多',
      myServers: '我的服务器',
      viewAll: '查看全部',
      unnamedServer: '未命名服务器',
      notConfigured: '未配置',
      noServers: '还没有服务器',
      addFirstServer: '添加你的第一台 Minecraft 服务器',
      addServer: '添加服务器',
      quickLinks: '快速入口',
      quickLink: {
        userDocs: '用户文档',
        userDocsDesc: '学习如何使用 UltiKits',
        devDocs: '开发文档',
        devDocsDesc: 'UltiTools API 参考',
        github: 'GitHub',
        githubDesc: '查看开源项目',
        status: '服务状态',
        statusDesc: 'UltiKits 服务监控',
      },
      ecosystem: 'UltiKits 生态',
      noModules: '暂无模块数据',
    },

    // --- Navigation ---
    nav: {
      home: '主页',
      servers: '服务器',
      member: '会员',
      modules: '模块库',
      developer: '开发者',
      admin: '管理',
      profile: '个人中心',
      logout: '退出登录',
      logoutMsg: '已退出登录',
    },

    // --- Server Tabs ---
    server: {
      tabs: {
        dashboard: '总览',
        players: '玩家管理',
        worlds: '世界管理',
        plugins: '插件管理',
        logs: '日志',
        settings: '设置',
        backups: '备份管理',
        errors: '错误报告',
      },

      // --- Dashboard ---
      dashboard: {
        title: '服务器总览',
        refresh: '刷新',
        onlinePlayers: '在线玩家',
        memory: '内存',
        serverInfo: '服务器信息',
        version: '版本',
        uptime: '运行时间',
        worldCount: '世界数',
        performanceMetrics: '性能指标',
        serverControl: '服务器控制',
        restart: '重启',
        shutdown: '关机',
        countdownRestart: '{n} 秒后重启',
        countdownShutdown: '{n} 秒后关闭',
        restartingMsg: '服务器正在重启...',
        shuttingDownMsg: '服务器正在关闭...',
        tpsGood: '良好',
        tpsFair: '一般',
        tpsLow: '低',
        cpuNormal: '正常',
        cpuHigh: '较高',
        cpuOverload: '过载',
        memNormal: '正常',
        memHigh: '较高',
        memVeryHigh: '过高',
        memoryUsage: '内存使用',
        notActivated: '服务器未激活。请启用 Pro 激活以使用管理功能。',
        serverOffline: '服务器离线',
        offlineDetail: '显示的数据为最后已知状态，命令将在服务器上线后执行。',
        connected: '已连接',
        disconnected: '断开',
        serverWentOffline: '服务器已离线',
        serverWentOnline: '服务器已上线',
        memoryHigh: '内存使用过高',
      },

      // --- Logs ---
      logs: {
        title: '服务器日志',
        filter: '日志筛选',
        realtime: '实时日志',
        realtimeEnabled: '已启用',
        realtimeStopped: '已停止',
        copyFeedback: '已复制',
        copyCount: '复制 ({n})',
        noLogs: '暂无日志',
      },

      // --- Terminal ---
      terminal: {
        title: '终端',
        stopLogStream: '停止日志流',
        startLogStream: '启动日志流',
        exitFullscreen: '退出全屏',
        fullscreen: '全屏',
        inputPlaceholder: '输入命令...',
        waitingForInput: '等待命令输入...',
      },

      // --- Settings ---
      settings: {
        navigation: '设置导航',
        fileManager: '文件管理',
        pluginConfig: '插件配置',
        serverConfig: '服务器配置',
        structuredConfig: '模块配置编辑器',
        configSnapshotHint: '数值来自服务器上次连接时上传的快照。刷新只会重新读取该快照，并非服务器当前文件；保存时只发送已改动的配置项。',
      },

      // --- Metrics ---
      metrics: {
        title: '性能历史',
        threshold: '阈值',
        memoryLabel: '内存',
        playersLabel: '玩家',
        loadingData: '加载性能数据...',
        loadFailed: '性能数据加载失败',
        noDataYet: '暂无数据，服务器在线至少 1 分钟后可查看。',
        avgTps: '平均 TPS',
        peakMemory: '峰值内存',
        peakPlayers: '峰值玩家',
        avgCpu: '平均 CPU',
      },

      // --- Players ---
      players: {
        title: '玩家管理',
        onlineCount: '在线玩家 ({n})',
        search: '搜索...',
        sortBy: '排序: {label}',
        sortName: '名称',
        sortHealth: '血量',
        sortWorld: '世界',
        teleport: '传送',
        kick: '踢出',
        noPlayers: '暂无在线玩家',
        notFound: '未找到 "{query}"',
        playerJoined: '{name} 加入了游戏',
        playerLeft: '{name} 离开了游戏',
        activity: '玩家动态',
        noActivity: '暂无动态',
        teleportedTo: '已传送至 {name}',
        teleportFailed: '传送失败: {msg}',
        kicked: '已踢出 {name}',
        kickFailed: '踢出失败: {msg}',
        kickDialogTitle: '踢出玩家',
        kickReason: '踢出原因（可选）',
        gamemodeSurvival: '生存',
        gamemodeCreative: '创造',
        gamemodeAdventure: '冒险',
        gamemodeSpectator: '旁观',
        gamemodeSet: '已设置 {name} 为 {mode}',
        gamemodeSetFailed: '设置游戏模式失败: {msg}',
      },

      // --- Worlds ---
      worlds: {
        title: '世界管理',
        loadedWorlds: '已加载世界',
        playerChunkInfo: '{players} 玩家 · {chunks} 区块',
        noWorldData: '暂无世界数据',
        worldBackups: '世界备份',
        noBackups: '暂无备份',
        createBackup: '创建备份',
        difficulty: '难度',
        onlinePlayers: '在线玩家',
        loadedChunks: '已加载区块',
        pvp: 'PVP',
        pvpOn: '开启',
        pvpOff: '关闭',
        spawnLocation: '出生点',
        diffPeaceful: '和平',
        diffEasy: '简单',
        diffNormal: '普通',
        diffHard: '困难',
      },

      // --- Plugins ---
      plugins: {
        title: '插件管理',
        sidebar: '插件列表',
        noPlugins: '暂无插件',
        search: '搜索插件...',
        noMatch: '未找到匹配插件',
        noPluginData: '暂无插件数据',
        reload: '重载',
        reloaded: '{name} 已重载',
        reloadFailed: '重载失败: {msg}',
      },

      // --- Backups ---
      backups: {
        title: '备份管理',
        overview: '备份概况',
        totalBackups: '总备份数',
        latestBackup: '最近备份',
        none: '无',
        quickActions: '快捷操作',
        creating: '创建中...',
        createBackup: '创建备份',
        refreshing: '加载中...',
        refreshList: '刷新列表',
        noBackups: '暂无备份',
        startHint: '点击"创建备份"开始',
        details: '备份详情',
        id: 'ID',
        time: '时间',
        status: '状态',
        restore: '恢复',
        confirmRestore: '确认恢复',
        confirmRestoreMsg: '确定要恢复此备份？当前服务器数据将被覆盖。',
        confirmDelete: '确认删除',
        confirmDeleteMsg: '确定要删除此备份？此操作不可撤销。',
        statusCompleted: '完成',
        statusInProgress: '进行中',
        statusPending: '等待中',
        statusFailed: '失败',
        fetchFailed: '获取备份列表失败: {msg}',
        createSent: '备份创建请求已发送',
        createFailed: '备份创建失败: {msg}',
        restoreSent: '备份恢复请求已发送',
        restoreFailed: '备份恢复失败: {msg}',
        deleted: '备份已删除',
        deleteFailed: '删除失败: {msg}',
      },

      // --- File Manager ---
      files: {
        loadFailed: '加载目录失败: {msg}',
        unsavedChanges: '当前文件有未保存的更改，是否放弃？',
        readFailed: '读取文件失败: {msg}',
        saved: '文件已保存',
        saveFailed: '保存失败: {msg}',
        deleteConfirm: '确定要删除 {name} 吗？',
        deleteConfirmDir: '（包含所有子文件）',
        deleted: '已删除 {name}',
        deleteFailed: '删除失败: {msg}',
        browser: '文件浏览器',
        emptyDir: '目录为空',
        selectFile: '选择文件开始编辑',
      },

      // --- Plugin Settings ---
      pluginSettings: {
        selectPlugin: '选择插件',
        noPluginData: '暂无插件数据',
        selectFile: '选择文件开始编辑',
        selectPluginHint: '选择左侧插件查看配置',
        loadFailed: '加载插件文件失败: {msg}',
        unsavedChanges: '当前文件有未保存的更改，是否放弃？',
        readFailed: '读取文件失败: {msg}',
        saved: '文件已保存',
        saveFailed: '保存失败: {msg}',
      },

      // --- Settings Panel (server.properties) ---
      settingsPanel: {
        title: '服务器配置',
        restartRequired: '需要重启以应用更改',
        saveConfig: '保存配置',
        general: '基本设置',
        motd: '服务器描述 (MOTD)',
        maxPlayers: '最大玩家数',
        viewDistance: '视距',
        simulationDistance: '模拟距离',
        spawnProtection: '出生保护半径 (0 = 关闭)',
        gameRules: '游戏规则',
        difficulty: '难度',
        diffPeaceful: '和平',
        diffEasy: '简单',
        diffNormal: '普通',
        diffHard: '困难',
        defaultGamemode: '默认游戏模式',
        gamemodeSurvival: '生存',
        gamemodeCreative: '创造',
        gamemodeAdventure: '冒险',
        gamemodeSpectator: '旁观',
        toggleSettings: '开关设置',
        pvp: 'PVP',
        allowNether: '允许下界',
        allowFlight: '允许飞行',
        spawnAnimals: '生成动物',
        spawnMonsters: '生成怪物',
        spawnNpcs: '生成NPC',
        enableCommandBlock: '命令方块',
        loadFailed: '加载配置失败: {msg}',
        configSaved: '服务器已确认配置保存成功',
        configSaveFailed: '配置提交失败: {msg}',
        pending: '正在提交配置，等待服务器确认…',
        unconfirmed: '服务器尚未确认配置是否生效，请检查服务器后再重试。',
        refused: '服务器拒绝了配置更新',
        confirmFailed: '无法确认服务器配置是否生效: {msg}',
        unavailable: '无法取得服务器的实际配置，已禁用保存；请直接在服务器上编辑 server.properties。',
      },
    },

    // --- Notifications ---
    notifications: {
      title: '通知',
      clearAll: '清空',
      noNotifications: '暂无通知',
    },

    // --- Error Reporting ---
    errors: {
      title: '错误报告',
      frameworkTitle: '框架错误',
      filterTitle: '筛选条件',
      filterAll: '全部',
      filterModule: '模块筛选',
      filterTrigger: '触发类型',
      unresolved: '未解决',
      resolved: '已解决',
      resolve: '标记已解决',
      unresolve: '标记未解决',
      resolvedSuccess: '已标记为解决',
      unresolvedSuccess: '已标记为未解决',
      expand: '展开',
      collapse: '收起',
      stats: '统计',
      totalErrors: '总错误数',
      unresolvedErrors: '未解决错误',
      noErrors: '暂无错误记录',
      stackTrace: '堆栈追踪',
      serverContext: '服务器上下文',
      memoryPercent: '内存占用',
      playerCount: '在线玩家',
      triggerDetail: '触发详情',
      details: '详细信息',
      firstSeen: '首次出现',
      lastSeen: '最后出现',
      occurrences: '出现次数',
      fingerprint: '指纹',
      triggerCommand: '命令',
      triggerEvent: '事件',
      triggerScheduled: '定时任务',
      triggerAop: 'AOP',
      triggerUncaught: '未捕获',
    },

    // --- 开发者错误报告 ---
    developerErrors: {
      title: '模块错误报告',
      subtitle: '使用你模块的服务器上报的汇总错误',
      totalErrors: '总错误数',
      unresolvedErrors: '未解决错误',
      topModule: '问题最多的模块',
      filterModule: '模块',
      filterStatus: '状态',
      total: '共 {n} 个错误',
    },

    // --- Server List ---
    serverList: {
      title: '服务器',
      summary: '{online} 个在线 · {total} 个服务器',
      addServer: '添加服务器',
      searchPlaceholder: '搜索服务器...',
      filter: '过滤...',
      uuidNotSet: '未设置 UUID',
      needUuid: '需设置UUID',
      noMatch: '未找到符合条件的服务器',
      adjustSearch: '尝试调整搜索条件或清除过滤器',
      addFirstServer: '添加你的第一台 Minecraft 服务器开始管理',
      autoRegisterNotice: '使用 UltiTools 6 无需手动添加，插件将自动注册服务器至 UltiKits Cloud。',
      serverName: '服务器名称*',
      serverDomain: '服务器域名*',
      domainExample: '如 minecraft.example.com',
      serverUuid: '服务器 UUID*',
      uuidHint: '可在 /plugin/UltiCore 文件夹下找到',
      serverIp: '服务器 IP 或域名',
      optional: '可选',
      activateNow: '立即激活服务器',
      setUuidTitle: '设置服务器 UUID',
      setUuidDesc: '为 {name} 设置 UUID。可在服务器的 /plugin/UltiCore 文件夹下找到。',
      uuidFormat: '格式：xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
      setUuid: '设置 UUID',
      nameRequired: '服务器名称不能为空',
      domainRequired: '服务器域名不能为空',
      uuidRequired: '服务器 UUID 不能为空',
      uuidEmpty: 'UUID 不能为空',
      uuidLength: 'UUID 格式不正确，应为36位',
      uuidFormat2: 'UUID 格式不正确',
      activated: '已激活',
      ssl: 'SSL',
      unactivated: '未激活',
      noSsl: '非SSL',
      fetchFailed: '获取服务器列表失败：{msg}',
      addSuccess: '添加服务器成功',
      addFailed: '添加服务器失败：{msg}',
      uuidUpdated: '服务器 "{name}" 的 UUID 已更新',
      uuidUpdateFailed: '更新 UUID 失败：{msg}',
      noServers: '还没有服务器',
    },

    // --- Member ---
    member: {
      congratulations: '恭喜',
      thankYou: '感谢您购买 UltiKits 会员',
      viewStatus: '查看我的会员状态',
      legacyNotice: '2021年2月14日前购买付费版 UltiTools 的用户请使用购得的激活码在下方 "兑换" 页处兑换 Pro 会员',
      wechatNotice: '关于目前微信支付不可用的问题',
      wechatNoticeDetail: '由于某些不可抗力因素，微信支付目前无法使用。如需购买 UltiKits Pro 会员，请使用支付宝或联系客服。',
      title: 'UltiKits 会员',
      subtitle: '升级到 Pro 会员，享受更高级的功能',
      proMember: 'Pro 会员',
      freeMember: '普通会员',
      validUntil: '有效期至 {date}',
      upgradeHint: '升级以解锁远程管理、实时监控等高级功能',
      activatableServers: '可激活服务器',
      tabPurchase: '购买',
      tabRedeem: '兑换',
      tabUpgrade: '升级',
      tabBilling: '账单',
    },

    // --- Purchase ---
    purchase: {
      loadingPrices: '加载价格中...',
      priceUnavailable: '无法获取价格',
      checkNetwork: '请检查网络后重试',
      reload: '重新载入',
      freeTrialTitle: '免费试用 7 天 Pro 会员',
      freeTrialDesc: '所有已通过邮箱验证的用户均可领取',
      claimTrial: '领取试用',
      trialCodeValid: '试用兑换码七天内有效，请及时使用',
      trialCodeOnce: '仅显示一次，请妥善保管',
      trialCodeBound: '与该账号绑定，其他账号不可用',
      selectPlan: '选择方案',
      paymentMethods: '本网站支持银行卡/支付宝/微信支付。如有其他支付需求，可与我们联系。',
      noRefund: '购买后原则上不提供退款，请确认需求后再进行购买。',
      autoActivate: '支付成功后将自动开通 Pro 会员；若已是 Pro 会员，则叠加时长。',
      selected: '已选择',
      total: '总计',
      submitOrder: '提交订单',
      getCodeFailed: '获取兑换码失败：{msg}',
      getPriceFailed: '获取价格失败: {msg}',
      invalidClientSecret: '未收到有效的clientSecret，请重试',
      invalidClientSecretFormat: '收到的clientSecret格式不正确，请联系客服',
      orderCreated: '订单创建成功',
      orderCreateFailed: '订单创建失败: {msg}',
      stripeNotInit: 'Stripe未正确初始化，请刷新页面重试',
      monthlyPlan: 'UltiKits Pro 月度会员',
      quarterlyPlan: 'UltiKits Pro 季度会员',
      semiAnnualPlan: 'UltiKits Pro 半年会员',
      annualPlan: 'UltiKits Pro 年度会员',
      daysPlan: 'UltiKits Pro {n}天会员',
      verifyEmailFirst: '请先验证邮箱',
      alreadyPro: '您已是 Pro 会员',
      clickToGetCode: '点击获取兑换码',
      stripeInitFailed: '支付系统初始化失败，请刷新页面重试',
      stripeLoadFailed: '支付系统加载失败: {msg}',
      paymentValidationFailed: '支付验证失败',
      paymentUnknownError: '支付过程中发生未知错误，请重试',
      paymentConfirmFailed: '支付确认失败: {msg}',
      orderCancelled: '订单取消成功',
      orderCancelFailed: '订单取消失败: {msg}',
      orderNotFound: '未找到订单，请重新下单',
      refreshStatus: '刷新状态',
      statusRefreshFailed: '无法刷新订单状态，请重试',
      statusVerified: '支付已验证。会员状态刷新确认权益后，Pro 功能即会开通。',
      statusPending: '支付尚未完成。请完成支付，或稍后刷新此状态。',
      statusUnverified: '已收到支付凭据但尚未完成验证，Pro 功能暂未开通。',
      statusFailed: '该笔支付已关闭或失败，请重新下单。',
    },

    // --- Redeem ---
    redeem: {
      guide: '兑换指南',
      guideDesc: '购买 UltiTools 付费版得到的激活码使用 CDK 激活；活动或免费试用的兑换码使用兑换码兑换。',
      cdkTitle: '使用 CD Key 激活',
      cdkPlaceholder: 'XXXX-XXXX-XXXX-XXXX',
      redeemTitle: '使用兑换码兑换',
      redeemPlaceholder: '输入兑换码',
      activateSuccess: '激活成功',
      activateFailed: '激活失败：{msg}',
      redeemSuccess: '兑换成功',
      redeemFailed: '兑换失败：{msg}',
    },

    // --- Upgrade ---
    upgrade: {
      currentServers: '当前可激活的服务器数量',
      upgradeHint: '升级以获取更多服务器配额',
      inDevelopment: '升级功能开发中',
      comingSoon: '此功能仍在施工中，敬请期待',
    },

    // --- Profile ---
    profile: {
      accountInfo: '账户信息',
      username: '用户名',
      email: '电子邮箱',
      emailVerified: '已验证',
      password: '登录密码',
      passwordSet: '已设置密码保护',
      preferences: '偏好设置',
      themeSettings: '主题设置',
      themeLight: '浅色',
      themeDark: '深色',
      themeAuto: '跟随系统',
      languageSettings: '语言设置',
      editEmail: '修改邮箱',
      editPassword: '修改密码',
      newEmail: '新邮箱地址',
      verificationCode: '验证码',
      codeSentTo: '验证码已发送至 {email}，请查收邮件',
      sendCode: '发送验证码',
      confirmEdit: '确认修改',
      newPassword: '新密码',
      confirmNewPassword: '确认新密码',
      stepEnterEmail: '输入新邮箱',
      stepVerifyEmail: '验证邮箱',
      codeSentSuccess: '验证码已发送到您的邮箱',
      sendFailed: '发送失败',
      emailChanged: '邮箱修改成功',
      verifyFailed: '验证失败',
      passwordChanged: '密码修改成功',
      changeFailed: '修改失败',
      emailRequired: '邮箱不能为空',
      emailInvalid: '邮箱格式不正确',
      passwordRequired: '密码不能为空',
      passwordMinLength: '密码至少6位',
      confirmPasswordRequired: '确认密码不能为空',
      passwordMismatch: '两次密码不一致',
      codeRequired: '验证码不能为空',
      codeLength: '验证码为6位数字',
      user: '用户',
      joinedAt: '{date} 加入',
      unknownDate: '未知',
      invalidDate: '时间格式错误',
      logout: '退出登录',
    },

    // --- Linked game identities ---
    linkedIdentities: {
      title: '已关联的游戏身份',
      loading: '正在加载已关联的游戏身份…',
      empty: '此账号尚未关联任何 Minecraft 玩家。在游戏中执行 /panel 即可关联。',
      unavailable: '已关联的游戏身份暂不可用。',
      loadFailed: '无法加载已关联的游戏身份：{message}',
      retry: '重试',
      server: '服务器',
      linkedAt: '关联于 {date}',
      ownerBadge: '服务器所有者',
      unlink: '解除关联',
      moveHint: '如需把 Minecraft 玩家关联到另一个账号：先在这里解除关联，再登录另一个账号，然后在游戏中重新执行 /panel。',
      dialog: {
        title: '解除 {name} 的关联？',
        consequenceOwner: '你是 {server} 的所有者。解除关联会在该服务器上把 Minecraft 玩家 {name} 从此账号移除。你仍保留 {server} 的所有权和面板访问权限。',
        consequencePlayer: '解除关联会在 {server} 上把 Minecraft 玩家 {name} 从此账号移除，你也会失去 {server} 的面板访问权限。',
        cancel: '取消',
        confirm: '解除关联',
      },
      result: {
        accessRemoved: '已解除 {name} 的关联。你在 {server} 的面板访问权限已被移除。',
        ownershipKept: '已解除 {name} 的关联。你仍是 {server} 的所有者。',
        alreadyUnlinked: '{name} 在 {server} 上已不再关联此账号。',
      },
      unlinkFailed: '解除关联失败：{message}',
      unknownError: '未知错误',
    },

    // --- Email Validation ---
    emailValidation: {
      hint: '验证电子邮箱，解锁更多功能',
      start: '开始验证',
      title: '邮箱验证',
      codeSentTo: '验证码已发送到 {email}',
      enterCode: '在下方输入你收到的6位验证码',
      resend: '重新发送',
      sendFailed: '发送验证码失败：{msg}',
      verifySuccess: '验证成功',
      verifyFailed: '验证失败：{msg}',
    },

    creatorInsights: {
      totalModules: '模块总数', cumulativeDownloads: '累计下载', totalLikes: '总点赞', totalComments: '总评论',
      loading: '正在加载创作者数据…',
      error: { title: '无法加载创作者数据' }, retry: '重试',
    },

    creatorModuleInsights: {
      title: '创作者数据', description: '此模块的累计指标与近期社区反馈',
      metrics: { downloads: '累计下载', likes: '点赞', comments: '评论', versionCount: '版本数' },
      activity: { title: '最近反馈与活动' },
      filter: { label: '筛选活动', all: '全部', comment: '评论', like: '点赞', versionPublished: '版本发布' },
      sort: { label: '排序活动', occurredAt: '发生时间', type: '活动类型', ascending: '升序', descending: '降序', toggleDirection: '切换排序方向' },
      table: { type: '活动类型', details: '详情', occurredAt: '发生时间', sortBy: '按{column}排序' },
      loading: '正在加载创作者数据…',
      empty: { title: '暂无近期活动', description: '当此模块收到评论、点赞或发布版本时，会显示在这里。' },
      noMatch: { title: '没有匹配的活动', description: '尝试其他活动类型，或清除筛选条件。', clearFilter: '清除活动筛选' },
      error: { title: '无法加载创作者数据', description: '请检查连接后重试。', retry: '重新加载创作者数据' },
      a11y: { insightsRegion: '创作者数据', activityRegion: '最近反馈与活动', filter: '筛选活动', sortField: '活动排序字段', sortDirection: '切换排序方向', sortColumn: '按{column}排序', retry: '重新加载创作者数据', metric: '{metric} 指标' },
    },

    moduleDetail: {
      a11y: {
        backToModules: '返回我的模块',
        editModule: '编辑 {name}',
        deleteModule: '删除 {name}',
      },
      actions: { edit: '编辑', delete: '删除', publishVersion: '发布新版本' },
      info: {
        shortDescription: '简短描述',
        description: '详细描述',
        category: '分类',
        uncategorized: '未分类',
        apiVersions: '兼容 API 版本',
        tags: '标签',
        createdAt: '创建时间',
        updatedAt: '最后更新',
      },
      versions: {
        title: '版本历史',
        latest: '最新',
        pendingUpload: '待上传',
        empty: '还没有发布任何版本',
      },
      deleteDialog: {
        title: '确认删除',
        description: '确定要删除模块 {name} 吗？此操作会永久删除所有版本和上传文件。',
        cancel: '取消',
        confirm: '确认删除',
      },
      toast: {
        notFound: '模块未找到',
        loadFailed: '加载模块详情失败',
        deleted: '模块已删除',
        deleteFailed: '删除模块失败：{message}',
        unknownError: '未知错误',
      },
    },

    // --- Developer Center ---
    developer: {
      title: '开发者中心',
      becomeDev: '成为 UltiKits 开发者',
      becomeDevDesc: '注册开发者账号，发布你的模块到 UltiKits 模块市场',
      register: '注册开发者',
      devName: '开发者名称',
      devNamePlaceholder: '你的开发者域名标识',
      devNameHint: '创建后不可修改，将作为你的模块存储路径',
      submitRegister: '提交注册',
      nameRequired: '开发者名称不能为空',
      registerSuccess: '开发者注册成功',
      registerFailed: '开发者注册失败: ',
      loadFailed: '加载失败',
      loadFailedDesc: '开发者信息加载失败，请重试',
      reload: '重新加载',
      manageModules: '管理模块',
      publishedModules: '已发布模块',
      storageQuota: '存储配额',
      latestUpdate: '最近更新',
      noActivity: '暂无',
      accessToken: '访问密钥',
      tokenCopied: '访问密钥已复制到剪贴板',
      myModules: '我的模块',
      manageAll: '管理全部',
      noDescription: '暂无描述',
      notPublished: '未发布',
      noModules: '还没有创建任何模块',
      noModulesDesc: '点击按钮开始创建你的第一个模块',
      createModule: '创建模块',
      resources: '开发者资源',
      quickLink: {
        devDocs: '开发文档',
        devDocsDesc: 'UltiTools API 开发指南',
        userDocs: '用户文档',
        userDocsDesc: 'UltiKits 使用文档',
        github: 'GitHub',
        githubDesc: '查看开源项目',
        marketplace: '模块市场',
        marketplaceDesc: '浏览所有模块',
      },
      date: {
        today: '今天',
        yesterday: '昨天',
        daysAgo: '{n} 天前',
        monthsAgo: '{n} 个月前',
      },
    },

    // --- Module Marketplace ---
    modules: {
      title: '模块市场',
      subtitle: '发现并安装模块来扩展你的服务器功能',
      totalCount: '{n} 个模块',
      searchPlaceholder: '搜索模块名称、描述或标识...',
      noDescription: '暂无描述',
      noMatch: '没有找到匹配的模块',
      noModules: '暂无可用模块',
      tryOtherKeywords: '尝试其他关键词或清空搜索',
      checkBackLater: '稍后再来看看吧',
      loadFailed: '无法加载模块列表',
      loadFailedHint: '未能连接到模块市场，请检查网络后重试。',
      retry: '重试',
      clearSearch: '清空搜索',
      prevPage: '上一页',
      nextPage: '下一页',
      categoryAll: '全部',
      sortNewest: '最新更新',
      sortByName: '按名称',
      category: {
        'utilities': '实用工具',
        'economy': '经济',
        'world-management': '世界管理',
        'social-chat': '社交聊天',
        'permissions-security': '权限安全',
        'gameplay': '玩法娱乐',
      },
      date: {
        today: '今天',
        yesterday: '昨天',
        daysAgo: '{n} 天前',
        monthsAgo: '{n} 个月前',
      },
    },

    admin: {
      title: '管理后台',
      subtitle: '平台概览与管理',
      tabs: {
        dashboard: '数据总览',
        users: '用户管理',
        servers: '服务器管理',
        redeem: '兑换码管理',
      },
      period: { '24h': '24小时', '7d': '7天', '30d': '30天', '90d': '90天' },
      stats: {
        totalRevenue: '总收入',
        paymentMethods: '{n} 种支付方式',
        onlineServers: '在线服务器',
        registeredTotal: '共 {n} 台注册',
        totalInstalls: '总安装量',
        thisMonth: '本月 +{n}',
        onlinePlayers: '在线玩家',
        acrossServers: '分布在 {n} 台服务器',
        totalUsers: '总用户数',
        proMembers: '{n} 位 Pro 会员',
        apiRequests: '今日 API 请求',
      },
      charts: {
        revenueTrend: '收入趋势',
        revenueYAxis: '收入 (\u00A5)',
        topServers: 'API 请求量 Top 服务器',
        requestCount: '请求数',
        serverPlayerActivity: '服务器与玩家活跃度',
        players: '玩家',
        servers: '服务器',
        userGrowth: '用户增长',
        newUsers: '新用户',
        proConversion: 'Pro 转化',
        downloads: '{n} 次下载 ({p}%)',
      },
      health: {
        title: '服务器健康状态',
        playersOnline: '{n} 名玩家在线',
        server: '服务器',
        tps: 'TPS',
        memory: '内存',
        cpu: 'CPU',
        players: '玩家',
        noMetrics: '暂无服务器上报指标',
      },
      moduleSection: {
        title: '模块市场',
        totalDownloads: '共 {n} 次下载',
        topModules: '热门模块',
      },
      users: {
        searchPlaceholder: '搜索用户名或邮箱...',
        id: 'ID',
        username: '用户名',
        email: '邮箱',
        role: '角色',
        proStatus: 'Pro 状态',
        joinDate: '注册时间',
        actions: '操作',
        noData: '暂无用户数据',
        adjustPro: '调整 Pro',
        changeRole: '修改角色',
        free: '免费',
        expired: '已过期',
        proRemaining: 'Pro (剩余{n}天)',
      },
      proDialog: {
        title: '调整 Pro 时长',
        user: '用户',
        currentStatus: '当前状态',
        days: '天',
        daysLabel: '天数 (正数增加, 负数减少)',
        cancel: '取消',
        confirm: '确认',
      },
      roleDialog: {
        title: '修改用户角色',
        user: '用户',
        adminWarning: '此操作将赋予该用户完整的管理员权限。',
        cancel: '取消',
        confirm: '确认',
      },
      servers: {
        searchPlaceholder: '搜索服务器名称或 IP...',
        id: 'ID',
        name: '名称',
        owner: '所有者',
        ip: 'IP',
        status: '状态',
        uuid: 'UUID',
        active: '活跃',
        inactive: '未激活',
        noData: '暂无服务器数据',
      },
      redeem: {
        createCode: '创建兑换码',
        code: '兑换码',
        targetUser: '目标用户',
        days: '天数',
        status: '状态',
        createdAt: '创建时间',
        expiresAt: '过期时间',
        actions: '操作',
        daysSuffix: '{n}天',
        clickToCopy: '点击复制',
        neverExpires: '永不过期',
        revoke: '撤销',
        noData: '暂无兑换码数据',
        used: '已使用',
        expired: '已过期',
        unused: '未使用',
        filterAll: '全部',
        filterUnused: '未使用',
        filterUsed: '已使用',
        filterExpired: '已过期',
      },
      createDialog: {
        title: '创建兑换码',
        success: '兑换码创建成功!',
        targetUsername: '目标用户名',
        proDays: 'Pro 天数',
        codeExpiry: '兑换码有效期 (天, 0=永不过期)',
        cancel: '取消',
        create: '创建',
        close: '关闭',
      },
    },
    module: {
      marketplace: '模块市场',
      backToMarketplace: '返回模块市场',
      notFound: '模块不存在',
      notFoundDesc: '找不到标识为 "{id}" 的模块',
      loadFailed: '无法加载该模块',
      loadFailedHint: '请求失败，模块可能仍然存在，请重试。',
      retry: '重试',
      tabs: {
        description: '描述',
        versions: '版本',
        comments: '评论',
      },
      description: {
        empty: '暂无详细描述',
      },
      versions: {
        title: '版本历史',
        latest: '最新',
        empty: '暂无版本记录',
        loadFailed: '版本记录加载失败',
        noChangelog: '暂无更新日志',
      },
      comments: {
        title: '社区评论',
        count: '{n} 条评论',
        placeholder: '写下你的评论...',
        charCount: '{n}/500',
        submit: '发送',
        loginHint: '登录后可以发表评论',
        empty: '暂无评论，来做第一个评论的人吧',
        loadFailed: '评论加载失败',
        loadMore: '加载更多',
      },
      sidebar: {
        install: '安装',
        download: '下载',
        metadata: '信息',
        version: '版本',
        published: '发布日期',
        updated: '更新日期',
        apiCompat: 'API 兼容',
        downloads: '下载次数',
        likes: '喜欢',
        publisher: '开发者',
        category: '分类',
        tags: '标签',
        noTags: '暂无标签',
      },
    },
  },

  // Vuetify locale overrides (accessed via Vuetify's $vuetify.* and useLocale t())
  vuetify: {
    app: {
      auth: {
        welcome: '欢迎回来',
        username: '用户名',
        password: '密码',
        register: '注册账号',
        forget: '忘记密码',
        email: '电子邮箱',
        pwdRepeat: '重复密码',
        backLogin: '返回登录',
        findAccount: '找回账号',
        account: '账号',
        usernameOrEmail: '用户名或电子邮箱',
        plzInputAccount: '请输入要找回的账号',
        verify: '验证',
        codeVerify: '身份验证',
        codeSendTo: '验证码已发送至',
        codeSent: '验证码已发送，请注意查收',
        codeSendFail: '发送验证码失败：',
        reSend: '重新发送',
        codeVerified: '身份验证成功',
        verifyFailure: '验证失败：',
        resetPwd: '重置密码',
        newPwd: '新密码',
        newPwdRepeat: '重复新密码',
        verifyExpire: '身份验证的有效期至',
        resetHint: '请在此之前完成密码重置操作',
        resetSuccess: '密码重置成功, 请使用新密码登录',
        resetFailure: '密码重置失败：',
        requiredField: '此为必填项',
        reset: '重置',
        pwdRequireMoreThan: '密码不能少于 {0} 个字符',
        pwdRequireOnlyAscii: '密码只能包含字母、数字和下划线',
        pwdNotMatch: '两次输入的密码不一致',
        subTitle: 'Spigot 服务器插件管理平台',
        profileFailure: '登录失败：无法获取用户信息，请稍后再试',
        loginSuccess: '登录成功：欢迎回来，',
        loginFailure: '登录失败：',
        badCredential: '登录失败：用户名或密码错误',
        accountNotExistOrPasswordError: '账号不存在或密码错误',
        usernameRequireMoreThan: '用户名不能少于 {0} 个字符',
        usernameRequireLessThan: '用户名不能多于 {0} 个字符',
        usernameRequireOnlyAscii: '用户名只能包含字母、数字和下划线',
        requireAvailableEmail: '请输入有效的电子邮箱',
        registerSuccess: '注册成功，请登录',
        registerFailure: '注册失败：',
        registerNetworkError: '无法连接到服务器，请检查网络连接后重试。',
        magicLink: '魔法链接登录',
        magicLinkSubtitle: '从 Minecraft 完成身份验证',
        magicLinkVerifying: '正在验证您的魔法链接...',
        magicLinkValid: '魔法链接验证成功！',
        magicLinkExpired: '此魔法链接已过期。请在 Minecraft 中重新运行 /panel。',
        magicLinkInvalid: '此魔法链接无效。请在 Minecraft 中重新运行 /panel 获取新链接。',
        magicLinkError: '验证魔法链接失败，请重试。',
        magicLinkPlayerName: 'Minecraft 玩家',
        magicLinkServerName: '服务器',
        magicLinkType: '操作',
        magicLinkTypeLogin: '登录已有账号',
        magicLinkTypeRegister: '创建新账号',
        magicLinkSetPassword: '为您的 Web 面板账号设置密码',
        magicLinkPasswordHint: '您以后可以使用此密码直接登录',
        magicLinkComplete: '完成身份验证',
        magicLinkCompleting: '正在完成身份验证...',
        magicLinkSuccess: '身份验证成功！正在跳转...',
        magicLinkFailure: '身份验证失败：',
        magicLinkOwnerWelcome: '欢迎，服务器管理员！',
        magicLinkPlayerWelcome: '欢迎！',
        magicLinkNoCode: '未提供魔法链接代码。请在 Minecraft 中运行 /panel 获取链接。',
        magicLinkUsed: '此链接已被使用。请在 Minecraft 中重新运行 /panel 获取新链接。',
        magicLinkBurned: '密码错误次数过多，此链接已被锁定。请在 Minecraft 中重新运行 /panel 获取新链接。',
        magicLinkRateLimited: '尝试次数过多，请等待几分钟后再试。',
        magicLinkSignedInAs: '当前登录账号',
        magicLinkStateBound: '此 Minecraft 玩家已绑定账号 {0}。请输入该账号的密码登录。',
        magicLinkTrustDevice: '记住此设备（30 天）',
        magicLinkLogin: '登录',
        magicLinkWrongPassword: '密码错误，请重试。',
        magicLinkDeviceLogin: '使用此已记住的设备登录',
        magicLinkDeviceHint: '此浏览器记住了一次登录。只有当你本人在 {1} 上以 {0} 执行了 /panel 时才使用它。',
        magicLinkDeviceForgotten: '此设备已不再被记住，请输入密码。',
        magicLinkStateChanged: '页面打开后状态已发生变化，已重新检查链接。',
        magicLinkLegacyLogin: '请输入您的 UltiKits 账号密码登录。',
        magicLinkStateUnbound: '服务器 {1} 上的 Minecraft 玩家 {0} 尚未绑定 UltiKits 账号。请创建新账号，或先登录已有账号再在那里绑定。',
        magicLinkCreateAccount: '创建新账号',
        magicLinkLoginExisting: '登录已有账号',
        magicLinkRegister: '创建账号并绑定',
        magicLinkStateConfirmLink: '将服务器 {1} 上的 Minecraft 玩家 {0} 绑定到您的账号 {2}？',
        magicLinkStateConfirmReplace: '您的账号 {2} 在服务器 {1} 上已绑定 Minecraft 玩家 {3}。确认后将用 {0} 替换 {3}，{3} 将不再绑定到您的账号。',
        magicLinkConfirm: '确认并绑定',
        magicLinkStateBoundToViewer: '此 Minecraft 玩家已绑定到您的账号，正在为您登录...',
        magicLinkRetry: '重试',
        magicLinkStateBoundToOther: '服务器 {1} 上的 Minecraft 玩家 {0} 已绑定到另一个账号（{2}），而不是您当前的账号 {3}。',
        magicLinkStateViewerHasIdentity: '您的账号在此服务器上已绑定 Minecraft 玩家 {0}。',
        magicLinkMoveHint: '如需把此身份移到当前账号：请登录另一个账号，在设置中解除绑定，然后在游戏中重新运行 /panel。',
        magicLinkSwitchAccount: '切换到账号 {0}',
        magicLinkCancel: '取消',
        magicLinkCancelled: '已取消，未进行任何绑定。此链接尚未被使用，在过期前仍然有效。',
        magicLinkReopen: '重新打开链接',
        magicLinkRefusalGameLogin: '此链接绑定新账号之前，请先在游戏中使用 /login 登录一次，然后重新运行 /panel。',
        magicLinkRefusalNotPermitted: '此服务器无法证明请求来自它本身，因此此链接只能登录该 Minecraft 玩家已绑定的账号。请联系服务器管理员更新 UltiLogin 并将服务器登录到 UltiCloud，然后重新运行 /panel。',
        serverLoginTitle: '服务器身份验证',
        serverLoginSubtitle: '将您的 UltiCloud 账号与 Minecraft 服务器关联',
        serverLoginVerifying: '正在验证登录请求...',
        serverLoginExpired: '此登录请求已过期。请在服务器上重新运行 /ulticloud login。',
        serverLoginError: '验证登录请求失败，请重试。',
        serverLoginNoId: '未提供登录请求 ID。请在 Minecraft 服务器上运行 /ulticloud login。',
        serverLoginServerName: '服务器名称',
        serverLoginModeLogin: '登录',
        serverLoginModeRegister: '注册',
        serverLoginUseCurrentSession: '使用当前登录的账号',
        serverLoginCurrentUser: '当前登录',
        serverLoginUseDifferentAccount: '使用其他账号',
        serverLoginLinkBtn: '关联服务器',
        serverLoginLoginBtn: '登录并关联服务器',
        serverLoginRegisterBtn: '注册并关联服务器',
        serverLoginSuccess: '身份验证成功！',
        serverLoginSuccessTitle: '服务器已关联！',
        serverLoginSuccessMsg: '您的服务器已与 UltiCloud 账号关联。您可以关闭此页面 — 服务器将自动完成连接。',
        serverLoginFailure: '身份验证失败：',
      },
      appBar: {
        server: '服务器',
        member: '会员',
        module: '模块库',
        dev: '开发者中心',
        profile: '个人中心',
        logout: '退出登录',
        logoutMsg: '已退出登录',
      },
    },
    badge: '徽章',
    open: '打开',
    close: '关闭',
    dataIterator: {
      noResultsText: '没有符合条件的结果',
      loadingText: '加载中……',
    },
    dataTable: {
      itemsPerPageText: '每页数目：',
      ariaLabel: {
        sortDescending: '：降序排列。',
        sortAscending: '：升序排列。',
        sortNone: '：未排序。',
        activateNone: '点击以移除排序。',
        activateDescending: '点击以降序排列。',
        activateAscending: '点击以升序排列。',
      },
      sortBy: '排序方式',
    },
    dataFooter: {
      itemsPerPageText: '每页数目：',
      itemsPerPageAll: '全部',
      nextPage: '下一页',
      prevPage: '上一页',
      firstPage: '首页',
      lastPage: '尾页',
      pageText: '{0}-{1} 共 {2}',
    },
    dateRangeInput: { divider: '至' },
    datePicker: {
      ok: '确定',
      cancel: '取消',
      range: { title: '选择日期', header: '输入日期' },
      title: '选择日期',
      header: '输入日期',
      input: { placeholder: '输入日期' },
    },
    noDataText: '没有数据',
    carousel: {
      prev: '上一张',
      next: '下一张',
      ariaLabel: { delimiter: '轮播 {0} 共 {1}' },
    },
    calendar: { moreEvents: '还有 {0} 项' },
    input: {
      clear: '清除 {0}',
      prependAction: '{0} 前置操作',
      appendAction: '{0} 后置操作',
      otp: '请输入 OTP 字符 {0}',
    },
    fileInput: {
      counter: '{0} 个文件',
      counterSize: '{0} 个文件（共 {1}）',
    },
    timePicker: { am: '上午', pm: '下午' },
    pagination: {
      ariaLabel: {
        root: '分页导航',
        next: '下一页',
        previous: '上一页',
        page: '转到页面 {0}',
        currentPage: '当前页 {0}',
        first: '第一页',
        last: '最后一页',
      },
    },
    stepper: { next: '下一步', prev: '上一步' },
    rating: { ariaLabel: { item: '评分 {0} 共 {1}' } },
    loading: '加载中...',
    infiniteScroll: { loadMore: '加载更多', empty: '没有更多了' },
  },
}
